// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-item {
  font-size: 13px;
  margin-right: 5px;
}

mat-card {
  direction: rtl;
  margin: 15px;
}

.text {
  font-size: 12px;
}

.buttons {
  margin-right: auto;
  margin-top: 20px;
}

.button-style {
  border-radius: 15px;
  height: 45px;
  font-size: 12px;
  width: 120px;
  margin-right: auto;
  margin-top: 15px;
  background-color: rgba(0, 0, 255, 0.7803921569) !important;
  color: white !important;
  margin-left: 10px;
}

.text1 {
  color: rgb(103, 125, 143) !important;
}

.text1.ng-star-inserted {
  width: 15rem;
  padding: 6px;
  margin-left: 5px;
  margin-right: 5px;
  border-radius: 10px;
  font-size: 13px;
  background-color: rgba(236, 225, 251, 0.8784313725) !important;
  margin-top: 20px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/features/contracts/contracts-card-item/contracts-card-item.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/contracts/contracts-card-item/contracts-card-item.component.scss"],"names":[],"mappings":"AACE;EACE,eAAA;EACA,iBAAA;ACAJ;;ADEE;EACE,cAAA;EACA,YAAA;ACCJ;;ADEC;EACE,eAAA;ACCH;;ADEC;EACC,kBAAA;EACA,gBAAA;ACCF;;ADEC;EACG,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,0DAAA;EACA,uBAAA;EACA,iBAAA;ACCJ;;ADGC;EACC,oCAAA;ACAF;;ADGA;EACE,YAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,8DAAA;EACA,gBAAA;EACA,kBAAA;ACAF","sourcesContent":["\r\n  .text-item{\r\n    font-size: 13px;\r\n    margin-right: 5px;\r\n  }\r\n  mat-card{\r\n    direction: rtl;\r\n    margin: 15px;\r\n  }\r\n\r\n .text{\r\n   font-size: 12px;\r\n }\r\n\r\n .buttons{\r\n  margin-right: auto;\r\n  margin-top: 20px;\r\n }\r\n\r\n .button-style{\r\n    border-radius: 15px;\r\n    height: 45px;\r\n    font-size: 12px;\r\n    width: 120px;\r\n    margin-right: auto;\r\n    margin-top: 15px;\r\n    background-color: #0000ffc7 !important;\r\n    color: white !important;\r\n    margin-left: 10px;\r\n  }\r\n \r\n\r\n .text1{\r\n  color: rgb(103, 125, 143) !important;\r\n }\r\n\r\n.text1.ng-star-inserted {\r\n  width: 15rem;\r\n  padding: 6px;\r\n  margin-left: 5px;\r\n  margin-right: 5px;\r\n  border-radius: 10px;\r\n  font-size: 13px;\r\n  background-color: #ece1fbe0 !important;\r\n  margin-top: 20px;\r\n  text-align: center;\r\n}\r\n",".text-item {\n  font-size: 13px;\n  margin-right: 5px;\n}\n\nmat-card {\n  direction: rtl;\n  margin: 15px;\n}\n\n.text {\n  font-size: 12px;\n}\n\n.buttons {\n  margin-right: auto;\n  margin-top: 20px;\n}\n\n.button-style {\n  border-radius: 15px;\n  height: 45px;\n  font-size: 12px;\n  width: 120px;\n  margin-right: auto;\n  margin-top: 15px;\n  background-color: rgba(0, 0, 255, 0.7803921569) !important;\n  color: white !important;\n  margin-left: 10px;\n}\n\n.text1 {\n  color: rgb(103, 125, 143) !important;\n}\n\n.text1.ng-star-inserted {\n  width: 15rem;\n  padding: 6px;\n  margin-left: 5px;\n  margin-right: 5px;\n  border-radius: 10px;\n  font-size: 13px;\n  background-color: rgba(236, 225, 251, 0.8784313725) !important;\n  margin-top: 20px;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
